import { Injectable, inject } from "@angular/core";

import { MailingAddressViewModel } from "@tylertech/tyler-api-types";

import { ContactService } from "./contact.service";

/**
 * @deprecated Usages should be replaced with `ContactService`
 */
@Injectable()
export class MailingAddressService
{
    private readonly $contactService = inject(ContactService);


    /**
     * @deprecated Usages should be replaced with `ContactService.UpdateMailingAddresses`
     */
    confirmAndSaveChanges(mailingAddresses: MailingAddressViewModel[]): Promise<MailingAddressViewModel[]>
    {
        return this.$contactService.UpdateMailingAddresses(mailingAddresses);
    }
}
